import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  PRODUCT_LIST: 'product-product'
}

const routes = [
  {
    path: 'product/',
    name: ROUTES.PRODUCT_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['product_product_list'],
      requiresAuth: true
    },
    component: () => import('./ProductList.vue')
  }
]

export { routes, ROUTES }
